import type {
  GlobalState, TabArgs,
  TabState,
} from '../types';

import { createInitialTabState } from '../helpers/tabStateFactory';
import { getCurrentTabId } from '../../util/establishMultitabRole';

export function selectTabState<T extends GlobalState>(
  global: T, ...[tabId = getCurrentTabId()]: TabArgs<T>
): TabState {
  const byTabId = global.byTabId || {};
  return byTabId[tabId]
    || byTabId[Object.keys(byTabId)[0] as unknown as number]
    || createInitialTabState(global, tabId, false);
}
